import { Color } from '@mui/material';
import { ValueOf } from 'type-fest';
import BaseGlobalStyles, { CustomGlobalStyles } from './GlobalStyles';
import type { CommonTheme } from './createMuiTheme';
import baseMakeStyles, { CustomMakeStyles } from './makeStyles';
import type {} from './muiOverrides';
import baseStyled, { CustomStyled } from './styled';

// TODO: re-enable this once we have turned the cssVariables flag back on
// import type {} from '@mui/material/themeCssVarsAugmentation';

export { keyframes } from 'tss-react';
export * from './constants';
export type { CommonTheme };

export const makeStyles = baseMakeStyles as CustomMakeStyles<CommonTheme>;

export const styled = baseStyled as CustomStyled<CommonTheme>;

export const GlobalStyles = BaseGlobalStyles as CustomGlobalStyles<CommonTheme>;

type ProperPalettes<T> = {
  [K in keyof T]: T[K] extends Omit<Color, 50 | 'A100' | 'A200' | 'A400' | 'A700'> ? K : never;
};

export type ThemePaletteName = ValueOf<ProperPalettes<CommonTheme['palette']>>;
